import PeopleIcon from 'assets/nav-icons/people.svg?react'
import MoneyIcon from 'assets/nav-icons/money.svg?react'
import CheckDoubleIcon from 'assets/nav-icons/check-double.svg?react'
import DocumentIcon from 'assets/nav-icons/document.svg?react'
import CalendarIcon from 'assets/nav-icons/calendar.svg?react'
import MapIcon from 'assets/nav-icons/map.svg?react'
import { NAV_TYPE_COLLAPSE, NAV_TYPE_ITEM } from 'constants/app.constant'

export const leads = {
    id: 'leads',
    type: NAV_TYPE_COLLAPSE,
    path: '/leads',
    title: 'Sales',
    transKey: 'Sales',
    Icon: PeopleIcon,
    permissionCode: "LEADLEADView",
    childs: [
        {
            id: 'leads.opportunities',
            type: NAV_TYPE_ITEM,
            path: '/leads/opportunities',
            title: 'Opportunities',
            transKey: 'Opportunities',
            Icon: MoneyIcon
        },
        {
            id: 'leads.activities',
            type: NAV_TYPE_ITEM,
            path: '/leads/activities',
            title: 'Activities',
            transKey: 'Activities',
            Icon: CheckDoubleIcon
        },
        {
            id: 'leads.activity-calendar',
            type: NAV_TYPE_ITEM,
            path: '/leads/activity-calendar',
            title: 'Activity Calendar',
            transKey: 'Activity Calendar',
            Icon: CheckDoubleIcon
        },
        // {
        //     id: 'leads.proposals',
        //     type: NAV_TYPE_ITEM,
        //     path: '/leads/proposals',
        //     title: 'Proposals',
        //     transKey: 'Proposals',
        //     Icon: DocumentIcon
        // },
        // {
        //     id: 'leads.map',
        //     type: NAV_TYPE_ITEM,
        //     path: '/leads/map',
        //     title: 'Map View',
        //     transKey: 'Map View',
        //     Icon: MapIcon
        // }
    ]
}
